import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './../../styles/cliente/home.css';
import * as globals from './../../components/GlobalScripts.js';
import Rating from './../rating/Rating';

const Cliente_home = () => {
    let path_api = localStorage.getItem('path_api');
    const [user, setUser] = useState([]);

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            setUser(userParsed);
        }
    }, []);

    const relevantReviews = user?.reviews?.filter(
        review => review.sender === user?.keylogin && review.type === "profesional"
    ) || [];

    const averageRating =
        relevantReviews.length > 0
            ? relevantReviews.reduce((sum, review) => sum + Number(review.rating), 0) / relevantReviews.length
            : 0;

    return (
        <>
            <div className='container-cliente page-home container-section'>
                <div className='left-side'>
                    <div className="profile-name">
                        <img src={path_api + user?.img_profile}></img>
                        <div className='flex-column gap-5'>
                            <h5>{user?.account?.nombre + ' ' + user?.account?.apellidos}</h5>
                            <Rating rating={averageRating} size={20} />
                            <p>
                                <b>Proyectos: </b>
                                {user?.proposal_active
                                    ? user.proposal_active.filter(project => project.sender === user?.keylogin).length
                                    : 0} en curso
                            </p>

                            <br />
                            <Link to="/cliente/cuenta"><b>Editar perfil</b></Link>
                        </div>

                    </div>
                </div>
                <div className="right-side">
                    <div className='flex-column gap-10'>
                        <h4>Proyectos en curso</h4>
                        <div className="projects">
                            {user?.proposal_active &&
                                user.proposal_active.filter(project => project.sender === user?.keylogin).length > 0 ? (
                                user.proposal_active
                                    .filter(project => project.sender === user?.keylogin)
                                    .map((project, index) => (
                                        <div key={index} className="project-item">
                                            <h4>Titulo</h4>
                                            <h5>{project.titulo}</h5>
                                            <h4 className='margin-top-15'>Descripción</h4>
                                            <p>{project.descripcion}</p>
                                            <p className='margin-top-15'>Costo: ${project.precio} MXN</p>
                                            <Link to={`/chat/${project.recieved}/`}>Ver proyecto</Link>
                                        </div>
                                    ))
                            ) : (
                                <h5>De momento no tienes proyectos en curso.</h5>
                            )}
                        </div>
                    </div>

                    <div className='flex-column gap-10'>
                        <h4>Últimos proyectos finalizados (7 dias)</h4>
                        <div className="projects">
                            {user?.proposal &&
                                user.proposal.filter(project => project.estado === "finalizada" && project.sender === user?.keylogin).length > 0 ? (
                                user.proposal
                                    .filter(project => project.estado === "finalizada" && project.sender === user?.keylogin)
                                    .map((project, index) => (
                                        <div key={index} className="project-item">
                                            <h4>Título</h4>
                                            <h5>{project.titulo}</h5>
                                            <h4 className='margin-top-15'>Descripción</h4>
                                            <p>{project.descripcion}</p>
                                            <p className='margin-top-15'>Costo: ${project.precio} MXN</p>
                                            <Link to={`/chat/${project.recieved}/`}>Ver chat</Link>
                                        </div>
                                    ))
                            ) : (
                                <h5>De momento no tienes proyectos finalizados.</h5>
                            )}
                        </div>
                    </div>

                    <div className='flex-column gap-10'>
                        <h4>Últimas propuestas realizadas (7 dias)</h4>
                        <div className="projects">
                            {user?.proposal && user.proposal.filter(project => project.estado !== "finalizada" && project.sender === user?.keylogin).length > 0 ? (
                                user.proposal
                                    .filter(project => project.estado !== "finalizada" && project.sender === user?.keylogin)
                                    .map((project, index) => (
                                        <div key={index} className="project-item">
                                            <h4>Título</h4>
                                            <h5>{project.titulo}</h5>
                                            <h4 className='margin-top-15'>Descripción</h4>
                                            <p>{project.descripcion}</p>
                                            <p className='margin-top-15'>Oferta por: ${project.precio} MXN</p>
                                            <p>Estado: {project.estado}</p>
                                            <Link to={`/chat/${project.recieved}/`}>Ver chat</Link>
                                        </div>
                                    ))
                            ) : (
                                <h5>Aún no has enviado propuestas.</h5>
                            )}
                        </div>
                    </div>

                    <div className='flex-column gap-10'>
                        {(() => {
                            const professionalReviews =
                                user?.reviews?.filter(
                                    review =>
                                        review.sender === user?.keylogin && review.type === "profesional"
                                ) || [];
                            return (
                                <>
                                    <h4>Calificaciones de profesionales ({professionalReviews.length})</h4>
                                    <div className="reviews">
                                        {professionalReviews.length > 0 ? (
                                            professionalReviews.map((review, index) => (
                                                <div key={index} className="review-item">
                                                    <div className="flex-row gap-20">
                                                        <img src={path_api + review.review_img_profile}></img>
                                                        <div className='flex-column gap-10'>
                                                            <h5>{review.review_nombre}</h5>
                                                            <Rating rating={review.rating} size={20} />
                                                            <p>{review.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <h5>No tienes reseñas para mostrar</h5>
                                        )}
                                    </div>
                                </>
                            );
                        })()}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Cliente_home;